import { render } from "./RequestFilters.vue?vue&type=template&id=884425a4&scoped=true"
import script from "./RequestFilters.vue?vue&type=script&lang=js"
export * from "./RequestFilters.vue?vue&type=script&lang=js"

import "./RequestFilters.vue?vue&type=style&index=0&id=884425a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-884425a4"]])

export default __exports__